// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jfkD","inner":"styles_inner__nmS6J","right":"styles_right__3yePy","close":"styles_close__2u4H-","footer":"styles_footer__1iXLp"};